import { fork, put, takeEvery } from 'typed-redux-saga/macro';

import { getInstance as getConfigServiceInstance } from 'Lib/ConfigService';
import { debugApp as debug } from 'Lib/debug';
import { GetActionByType } from 'Lib/reduxType';
import { withErrorHandling } from 'Lib/sagaHelpers';

import { FETCH_META_SUCCESS } from 'Store/meta/constants';

import { leversParsed } from '../actions';
import { GET_EXPERIMENTS_SUCCESS } from '../constants';

export function* parseLeversSaga(
  action: GetActionByType<typeof GET_EXPERIMENTS_SUCCESS | typeof FETCH_META_SUCCESS>
) {
  const { levers } = action.payload.result || {};
  debug('parse levers', action.type, levers);
  if (levers) {
    getConfigServiceInstance().receiveLevers(levers);
    yield* put(leversParsed(levers));
  }
}

export const leversRootSaga = withErrorHandling(
  function* _leversRootSaga() {
    debug('root levers saga');
    yield* takeEvery([GET_EXPERIMENTS_SUCCESS, FETCH_META_SUCCESS], parseLeversSaga);
  },
  { name: 'leversRootSaga' }
);

export function* registerLevers() {
  yield* fork(leversRootSaga);
}
